


























import { Component, Prop, Vue } from "vue-property-decorator";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { UserConfigColors } from "@/userConfigColors/userConfigColors";
import { UserAgentHelper } from "@/helper/userAgentHelper";

import CheckOn from "../resources/checkOn.vue";

@Component({
  components: {
      CheckOn
  }
})

export default class PrintRotationAlert extends Vue 
{
    // 表示確認用
    private isVisible = false;
    private completion : (() => void) | null = null;
    private get title() { return "！印刷の向きについてのご注意！"; }
    private get message1() { return "用紙選択時に用紙を「横向き」に設定しています。"; }
    private get message2() { return "プリンタ設定の印刷の向きも「横向き」に設定してください。"; }
    
    private ischeck = false;

    public isAvailable()
    {
        return !(CookieHelper.getItem("printRotationAlert") === true);
    }

    public open(completion : () => void)
    {
        this.isVisible = true;
        this.completion = completion;
        
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    private onOk()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;

        // クッキーに"表示しない"チェック状態保持
        CookieHelper.setItem("printRotationAlert", this.ischeck);

        this.isVisible = false;
        if(this.completion != null) { this.completion(); }
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigButtonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
